/*
 * Файл нужен, чтобы разорвать циклическую зависимость
 * reactApp/modules/editor/editor.selectors.ts -> reactApp/modules/storage/storage.selectors.ts -> reactApp/modules/editor/editor.selectors.ts
 */
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import type { EditorState } from './editor.types';

export const getEditorState = (state: RootState): EditorState => state.editor;

export const getEditorItem = createSelector(getEditorState, (state) => state.item);

export const getEditorItemById = createSelector(
    getEditorItem,
    (_: RootState, id: string) => id,
    (item, id) => {
        if (item && item.id === id) {
            return item;
        }
    }
);
